import { createSelector } from '@ngrx/store';

import { LiveStreamSelectors } from '../../../live-stream/redux/live-stream.reducer';
import { HuntingProductsSelectors } from '../../../redux/hunting-products.reducer';

/** Visual states of the combined connect/setup sheet. */
export type SheetPhase = 'connecting' | 'liveStreamStarting' | 'failed' | 'liveStreamFailed';

/**
 * One sheet, one continuous progress story: joining the device AP, then (for the live-stream
 * intent) setting the stream up, then failure states for either phase. The former green
 * "connected" stopover is gone — the AP being up is not a goal, the stream (or sync) is.
 */
export const CannesWifiConnectSheetSelectors = {
  getSheetPhase: createSelector(
    HuntingProductsSelectors.getCannesWifiState,
    HuntingProductsSelectors.getCannesWifiIntent,
    LiveStreamSelectors.streamStatus,
    (wifiState, intent, streamStatus): SheetPhase => {
      if (wifiState === 'failed') return 'failed';
      if (intent === 'liveStream' && wifiState === 'connected') {
        return streamStatus === 'error' ? 'liveStreamFailed' : 'liveStreamStarting';
      }
      return 'connecting';
    }
  ),
};
